import {z} from 'zod';
import {BatchJobProgressMessageSchema} from '@netx/core-app-next/schema';
import {AssetSetType} from './assetSetSchema';
// import {DownloadOptionType} from './downloadOptionSchema';

// export enum ProgressMessageObjectType {
//     ASSET = 'asset',
//     SYNC_CLIENT_DELTA = 'syncClientDelta',
//     ATTRIBUTE_DATA_IMPORT = 'attributeDataImport',
//     USER_DATA_IMPORT = 'userDataImport',
//     ATTRIBUTE_DATA_IMPORT_ROW = 'attributeDataImportRow',
//     USER_DATA_IMPORT_ROW = 'userDataImportRow',
// }

// export enum ProgressMessageTaskType {
//     ALL = 'all',
//     METADATA = DownloadOptionType.METADATA,
//     SYNC_CLIENT_ANALYSIS = 'SyncClientAnalysis',
//     USER_IMPORT = 'UserImport',
// }

export const DownloadWarningProgressMessageSchema =
	BatchJobProgressMessageSchema.omit({
		objectType: true,
		// taskType: true,
	}).extend({
		objectType: z.nativeEnum(AssetSetType),
		// taskType: z.nativeEnum(ProgressMessageTaskType),
	});

export const DownloadWarningsSchema = z.object({
	messageCount: z.number().int().gt(-1, 'Invalid count'),
	progressMessages: z.array(DownloadWarningProgressMessageSchema),
});

export type IDownloadWarnings = z.infer<typeof DownloadWarningsSchema>;

export type IProgressMessage = z.infer<
	typeof DownloadWarningProgressMessageSchema
>;
